import img1 from '../assets/images/sale1.png'
import img2 from '../assets/images/sale2.png'
import img3 from '../assets/images/sale3.png'

export const featuredData = [
    {
        id:1,
        image: img1,
        heading: 'Phones Sale',
        button: 'Shop Now',
        position:'left'
    },
    {
        id:2,
        image: img2,
        heading: 'Electronics Sale',
        button: 'Shop Now',
        position:'right'
    },
    {
        id:3,
        image: img3,
        heading: 'Furniture Offer',
        button: 'Shop Now',
        position:'right'
    },

]